const SOURCE_NAME_FIELDS = [
  'in_name',
  'name',
  'character_name',
  'location_name',
  'label',
  'in_file_name',
]

function stringField(data: object, key: string): string | undefined {
  const value = Reflect.get(data, key)
  return typeof value === 'string' && value.trim() ? value.trim() : undefined
}

/** Build the annotated result's name from the source node's visible identity. */
export function buildAnnotatedNodeLabel(
  sourceNode: { id: string; data: object },
  annotatedSuffix: string,
): string {
  const sourceName = SOURCE_NAME_FIELDS
    .map((field) => stringField(sourceNode.data, field))
    .find((value) => value !== undefined) ?? sourceNode.id
  return `${sourceName} - ${annotatedSuffix}`
}
